import { ImmutableMap } from "~/tools/immutable-map";
import { Impulse, type Scope } from "~/tools/impulse";

/**
 * Manages a persistent storage state using an internal map of string keys to Impulse-wrapped string values.
 * Provides methods to reactively get, set, remove, and clear items in the storage.
 */
export class PersistentStorageState {
	private readonly state = Impulse(ImmutableMap.empty<string, undefined | Impulse<string>>());

	public getItem(scope: Scope, key: string): undefined | string {
		return this.state.getValue(scope).get(key)?.getValue(scope);
	}

	public setItem(key: string, value: string): void {
		this.state.setValue((state) => {
			const current = state.get(key);

			// the item was not existing
			if (current == null) {
				return state.set(key, Impulse(value));
			}

			// update existing item
			current.setValue(value);

			// without updating the map
			return state;
		});
	}

	public removeItem(key: string): void {
		// assign `undefined` when removing so that subscribers get notified
		this.state.setValue((state) => state.set(key, undefined));
	}

	public clear(): void {
		this.state.setValue((state) => state.clear());
	}
}
